import React, { ReactElement, ReactNode } from "react";
import { styled, Typography } from "@mui/material";
import { Link, convertPxToRem } from "@treez-inc/component-library";
import ErrorTile from "components/ErrorTile";
import Header from "components/Header";

export interface FormProps {
  children: ReactNode;
  Description?: () => ReactElement;
  formSubmitError: string | null;
  hideSupportCenterLink?: boolean;
  pageTitle: string;
}

const Container = styled("div")({
  width: "100%",
  minWidth: convertPxToRem(320),
  maxWidth: convertPxToRem(400),
  margin: "0 auto",
});

const Title = styled(Typography)({
  marginBottom: convertPxToRem(24),
});

const DescriptionContainer = styled("div")({
  marginBottom: convertPxToRem(16),
  // Typography
  "> span": {
    display: "block",
    marginBottom: convertPxToRem(24),
  },
});

const StyledForm: React.FC<FormProps> = ({
  children,
  Description,
  formSubmitError,
  hideSupportCenterLink = false,
  pageTitle,
}) => (
  <Container data-testid="styled-form-container">
    <Header />
    <Title data-testid="styled-form-title" variant="h4">
      {pageTitle}
    </Title>
    {Description && (
      <DescriptionContainer data-testid="styled-form-description">
        <Description />
      </DescriptionContainer>
    )}
    {formSubmitError && <ErrorTile errorMessage={formSubmitError} />}
    {children}
    {!hideSupportCenterLink && (
      <Link
        testId="support-center-link"
        ariaLabel="support center link"
        href="https://support.treez.io/hc/en-us"
        underline="always"
        newTab
      >
        Support Center
      </Link>
    )}
  </Container>
);

export default StyledForm;
